const TOKEN_KEY = 'rastel:token';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || null;
export const saveToken = (token: string) =>
  localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
